import { useCallback, useEffect, useMemo, useState } from 'react';
import { darkTheme, lightTheme } from '../theme/themes';

const themes = {
  light: lightTheme,
  dark: darkTheme,
};

export function useThemeConfig() {
  const storagedTheme = JSON.parse(localStorage.getItem('menucheff@theme'));
  const storagedColor = JSON.parse(
    localStorage.getItem('menucheff@primaryColor'),
  );

  const [themeSchema, setThemeSchema] = useState(
    storagedTheme?.choosedTheme ?? 'light',
  );
  const [primaryColor, setPrimaryColor] = useState(
    storagedColor?.primaryColor ?? '#0043ff',
  );

  const theme = useMemo(
    () => (themeSchema === 'light' ? themes.light : themes.dark),
    [themeSchema],
  );

  const handleTheme = useCallback((choosedTheme = '') => {
    if (!choosedTheme) {
      return;
    }
    if (choosedTheme) {
      setThemeSchema(choosedTheme);
      localStorage.setItem(
        'menucheff@theme',
        JSON.stringify({
          choosedTheme,
        }),
      );
    }
  }, []);

  const handlePrimaryColor = useCallback((newPrimaryColor = '') => {
    if (!newPrimaryColor) {
      return;
    }
    if (newPrimaryColor) {
      setPrimaryColor(newPrimaryColor);
      localStorage.setItem(
        'menucheff@primaryColor',
        JSON.stringify({
          primaryColor: newPrimaryColor,
        }),
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.setProperty(
      '--background-color',
      theme.colors.background,
    );
    document.body.style.setProperty(
      '--background-secondary-color',
      theme.colors.backgroundSecondary,
    );
    document.body.style.setProperty('--primary-color', primaryColor);
    document.body.style.setProperty('--text-color', theme.colors.text);
    document.body.style.setProperty(
      '--text-secondary-color',
      theme.colors.textSecondary,
    );
    document.body.style.setProperty(
      '--text-light-gray-opacity-color',
      theme.colors.lightGrayOpacity,
    );
  }, [theme, primaryColor]);

  return {
    theme: {
      ...theme,
      colors: {
        ...theme.colors,
        primary: primaryColor,
      },
    },
    themeSchema,
    handleTheme,
    handlePrimaryColor,
  };
}
